import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M12.074 8.784c2.246-.946 6.148-3.113 1.684-5.25-1.98-.945-3.96-.518-5.645.367C4.684 5.671 2.91 9.241 3 13.209c.118 4.182 3.37 7.294 6.384 8.18 2.749.824 6.06.366 8.217-1.557 3.074-2.686 3.636-5.34 3.222-7.477"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.177 12.904s1.36 3.235 2.365 3.144C13.433 15.926 21 4.542 21 4.542"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const CorrectIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
